import { PackageCheck, Sparkles, Truck } from "lucide-react";
import { Eyebrow, FadeUp, MaskLines } from "./Motion";

const PROMISES = [
  { icon: Truck, title: "On-time home delivery", text: "Planned three days ahead, so it arrives exactly when the muhurtham does." },
  { icon: PackageCheck, title: "Best packaging for freshness", text: "Wrapped to keep every petal cool, fragrant and intact on the way." },
  { icon: Sparkles, title: "Professional décor services", text: "Our team can set up the décor on-site, start to finish." },
];

export const BookingNotice = () => (
  <section className="relative overflow-hidden bg-[#FFF8EF] py-14 text-[#240620] sm:py-20" data-testid="booking-notice-section">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <Eyebrow className="!text-[#A0216B]">How booking works</Eyebrow>
        <h2 className="mt-4 font-display text-6xl font-semibold uppercase leading-[0.9] tracking-tight sm:text-7xl lg:text-[6.5rem]" data-testid="three-days-heading">
          <MaskLines lines={["Three days", <span key="p" className="italic normal-case font-medium text-[#A0216B]">prior booking.</span>]} />
        </h2>
        <FadeUp delay={0.2} className="mt-8 max-w-xl">
          <p className="inline-block rounded-full bg-[#240620] px-5 py-2 text-sm font-semibold text-[#F3E5AB]">This is not an instant delivery service</p>
          <p className="mt-5 text-base leading-relaxed text-[#4a2443] sm:text-lg">
            We undertake three days prior booking to do the best home delivery service — with the best packaging and professional décor services.
          </p>
        </FadeUp>
      </div>
      <div className="space-y-4 lg:col-span-5 lg:pt-8">
        {PROMISES.map((p, i) => (
          <FadeUp key={p.title} delay={i * 0.1} className="group flex gap-5 rounded-[24px] border border-[#240620]/10 bg-white/70 p-6 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-35px_rgba(36,6,32,0.5)]">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#240620] text-[#F3E5AB] transition-transform duration-500 group-hover:rotate-12">
              <p.icon size={20} />
            </span>
            <div>
              <h3 className="font-display text-2xl font-semibold">{p.title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-[#4a2443]">{p.text}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
